"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PretPourLeGrandSaut() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="236161" id="klar-for-å-automatisere" className="bg-background text-foreground relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[100vw] max-h-[1000px] w-[100vw] max-w-[1000px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-20 blur-[100px]"></div>

      {}
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,#3b82f612_1px,transparent_1px),linear-gradient(to_bottom,#3b82f612_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      <div className="container relative z-10 flex flex-col items-center px-4">
        <h2 ref={ref} className={`font-default mb-16 text-center text-[clamp(2.5rem,5vw,8rem)] font-extrabold uppercase leading-[0.9] tracking-tighter transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          Klar for å <br />
          <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">automatisere?</span>
        </h2>

        <Link to="https://xora.no/priser/" className="group relative w-[90vw] md:w-[50vw]">
          {}
          <div className="absolute -inset-1 animate-pulse bg-gradient-to-r from-primary to-accent opacity-40 blur-xl transition-opacity duration-500 group-hover:opacity-80"></div>
          
          <Button size="lg" className="relative h-20 w-full rounded-xl border border-white/10 bg-surface/40 backdrop-blur-md text-xl font-bold uppercase tracking-widest text-foreground transition-all duration-300 hover:bg-primary hover:text-primary-foreground md:h-28 md:text-3xl shadow-2xl">Kom i gang</Button>
        </Link>
      </div>
    </section>;
}